import Vue from 'vue';
import VueRouter from 'vue-router';
import { RouteConsts } from './route';
import { RawLocation, Route } from 'vue-router/types';
import StoreModule from '@/store/index';
import TopPage from '@/pages/TopPage.vue';
import { PageCategory } from '@/common/consts';
import ProductDetailPage from '@/pages/ProductDetailPage.vue';
import DocsPage from '@/pages/DocsPage.vue';
import TermsPage from '@/pages/TermsPage.vue';
import NotFoundPage from '@/pages/NotFoundPage.vue';
import AsctPolicyPage from '@/pages/AsctPolicyPage.vue';
import SupportPage from '@/pages/SupportPage.vue';
import TutorialsPage from '@/pages/TutorialsPage.vue';
import TutorialStepPage from '@/pages/TutorialStepPage.vue';

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(
  location: RawLocation
): Promise<Route> {
  return new Promise(() => {
    originalPush.call(
      this,
      location,
      () => {},
      () => {}
    );
  });
};

Vue.use(VueRouter);

const routes = [
  // トップページ
  {
    path: '/',
    name: RouteConsts.StoreTopPage,
    component: TopPage,
    meta: {
      pageCategory: PageCategory.MARKET_PLACE,
      isHeaderDesignApply: true
    },
    alias: '/index.html'
  },
  // 商品詳細
  {
    path: '/products/:product_id',
    name: RouteConsts.ProductDetailPage,
    component: ProductDetailPage,
    meta: {
      pageCategory: PageCategory.MARKET_PLACE,
      isHeaderDesignApply: true
    }
  },
  // サービス概要
  // {
  //   path: '/about',
  //   name: RouteConsts.AboutPage,
  //   component: AboutPage,
  //   meta: { pageCategory: PageCategory.MARKET_PLACE, isHeaderDesignApply: true }
  // },
  // デベロッパーガイド
  {
    path: '/docs',
    name: RouteConsts.DocsPage,
    component: DocsPage,
    props: true,
    meta: { pageCategory: PageCategory.MARKET_PLACE, isHeaderDesignApply: true }
  },
  // チュートリアルの一覧
  {
    path: '/tutorials',
    name: RouteConsts.TutorialsPage,
    component: TutorialsPage,
    props: true,
    meta: { pageCategory: PageCategory.MARKET_PLACE, isHeaderDesignApply: true }
  },
  // チュートリアルの各ステップ詳細
  {
    path: '/tutorials/:tutorial_id/:step_id',
    name: RouteConsts.TutorialStepPage,
    component: TutorialStepPage,
    meta: {
      pageCategory: PageCategory.MARKET_PLACE,
      isHeaderDesignApply: true
    }
  },
  // 利用規約
  {
    path: '/terms',
    name: RouteConsts.TermsPage,
    component: TermsPage,
    meta: {
      pageCategory: PageCategory.MARKET_PLACE,
      isHeaderDesignApply: true
    }
  },
  // 特定商取引画面
  {
    path: '/asct',
    name: RouteConsts.AsctPolicyPage,
    component: AsctPolicyPage,
    meta: { pageCategory: PageCategory.MARKET_PLACE, isHeaderDesignApply: true }
  },
  // サポート問い合わせ
  {
    path: '/support',
    name: RouteConsts.SupportPage,
    component: SupportPage,
    meta: { pageCategory: PageCategory.MARKET_PLACE, isHeaderDesignApply: true }
  },
  {
    path: '*',
    name: RouteConsts.NotFoundPage,
    component: NotFoundPage,
    meta: {
      pageCategory: PageCategory.MARKET_PLACE,
      isHeaderDesignApply: true
    }
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash
      };
    } else {
      // 基本はページ遷移時にページ最上部から表示
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach((to, _from, next) => {
  StoreModule.setPageCategory({
    pageCategory: to.meta.pageCategory
  });
  StoreModule.setIsHeaderDesignApply({
    isHeaderDesignApply: to.meta.isHeaderDesignApply
  });
  next();
});

export default router;
